import { authService } from "services/auth.service";
import { useMutation } from "@tanstack/react-query";
import { useAuth } from "context/AuthContext";
import { LoginInput } from "@/happypaws-shared/src/Authentication/models/LoginInput";

export const useLogin = () => {
  const { setUser } = useAuth();

  return useMutation({
    mutationFn: (data: LoginInput) => authService.login(data),
    onSuccess: (response) => {
      setUser(response);
    },
    onError: (error: any) => {
      console.error("Login error:", error);
    },
  });
};
